export const LOW = {
    value: "LOW",
    key: "clients.client.categorisation.categoryForm.form.requirementLevelTypes.low",
  };
  
  export const MEDIUM = {
    value: "MEDIUM",
    key: "clients.client.categorisation.categoryForm.form.requirementLevelTypes.medium",
  };
  
  export const HIGH = {
    value: "HIGH",
    key: "clients.client.categorisation.categoryForm.form.requirementLevelTypes.high",
  };
  
  export default [LOW, MEDIUM, HIGH];
  


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationRequirementLevelTypes.js